import gql from "graphql-tag";
import {
  ValidateImportProduct,
  ValidateImportProduct_validateImportProducts
} from "@/models/mutations/types/ValidateImportProduct";

export const VALIDATE_IMPORT_PRODUCTS_MUTATION = gql`
  mutation ValidateImportProduct($products: [ProductImportInput!]!) {
    validateImportProducts(products: $products) {
      kun
      anr
      type
      additionalInfo
    }
  }
`;

export type ValidateImportProductResult = ValidateImportProduct;
export type ValidateImportProductError = ValidateImportProduct_validateImportProducts;
